import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { TenantsService } from './core/services/tenants.service';
import { companyConfigService } from './core/services/company-config.service';
import { CurrencySettingsService } from './core/services/currency-setting.service';
import { IndexedDbService } from './core/services/indexed-dbservice.service';
import { AuthService } from './core/services/auth-service.service';
import { NotificationService } from './core/services/notification.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Taveelo B2B';
  lastUpdate: number = 0;
  constructor(
    private tanentser: TenantsService,
    private cookieService: CookieService,
    private companyConfigService: companyConfigService,
    private dbService: IndexedDbService,
    private currencySettings: CurrencySettingsService,
    private auth: AuthService,
    private notification: NotificationService
  ) {
    // Load the app configuration
    ['click', 'mousemove', 'keydown', 'scroll'].forEach(event => {
      window.addEventListener(event, () => {
        this.updateActivity();
      });
    });

  }
  ngOnInit(): void {
    // Synchronize RTL and language on app load
    const userLang = (localStorage.getItem('userLang') || 'EN').toUpperCase();
    if (userLang === 'AR') {
      document.documentElement.setAttribute('dir', 'rtl');
      document.documentElement.setAttribute('lang', 'ar');
      document.body.setAttribute('dir', 'rtl');
      document.body.classList.add('arabic-font');
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
      document.documentElement.setAttribute('lang', 'en');
      document.body.setAttribute('dir', 'ltr');
      document.body.classList.remove('arabic-font');
    }

    // const token = this.cookieService.get('authToken');
    const CompanyId = this.tanentser.getTenantFromSubdomain();
    let currData: any;
    this.dbService.getData('userCurr').then(data => {
      currData = data;
      if (currData) {
        this.currencySettings.setCurrency(currData.TargetCurrency, currData.SellROE);
      }
    });
    console.log(this.companyConfigService.getConfig());
  }

  async updateActivity() {
    const nowUtc = this.auth.getCurrentUtcTime();
    if (nowUtc - this.lastUpdate < 5000) return;
    this.lastUpdate = nowUtc;

    const userData: any = await this.dbService.getData('userInfo');
    if (!userData) return;

    const tokenExpiryUtc = this.auth.parseUtcTime(userData.tokenExpTime);

    // invalid ya expired in UTC → logout
    if (!tokenExpiryUtc || isNaN(tokenExpiryUtc) || nowUtc >= tokenExpiryUtc) {
      this.notification.error("Token Expired! Please login again")
      await this.auth.logout();
      return;
    }

    // ✅ activity update karo
    userData.lastActivityTime = nowUtc;
    await this.dbService.setData('userInfo', userData);
  }

}
